<template>
    <rkm-modal
        extra-large
        ref="RkmModal"
        title="Problema/condição avaliado"
    >
        <rkm-form
            ref="RkmForm"
            show-legend
        >
            <rkm-row>
                <rkm-col cols="6">
                    <rkm-form-input-autocomplete
                        :repository="repositories.ciap"
                        :search-fields="fields.ciap"
                        :text-field="(item) => `${item.codigo} - ${item.descricao}`"
                        :validations="validations.ciap"
                        @select="model.cid = null"
                        label="CIAP 2"
                        v-model="model.ciap"
                    />
                </rkm-col>

                <rkm-col cols="6">
                    <rkm-form-input-autocomplete
                        :repository="repositories.cid"
                        :search-fields="fields.cid"
                        :text-field="(item) => `${item.codigo} - ${item.nome}`"
                        :validations="validations.cid"
                        @select="model.ciap = null"
                        label="CID 10"
                        v-model="model.cid"
                    />
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col cols="12">
                    <rkm-form-radio-group
                        :options="data.form.situacoes"
                        :validations="validations.situacao"
                        label="Situação"
                        text-field="nome"
                        v-model="model.situacaoId"
                        value-field="id"
                    />
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col cols="12">
                    <rkm-form-textarea
                        :validations="validations.observacao"
                        label="Observações"
                        rows="4"
                        v-model="model.observacao"
                    />
                </rkm-col>
            </rkm-row>
        </rkm-form>

        <template v-slot:footer="{cancel}">
            <rkm-button @click="cancel">
                Fechar
            </rkm-button>

            <rkm-button
                @click="save"
                color="primary"
            >
                {{ item ? 'Salvar' : 'Incluir' }}
            </rkm-button>
        </template>
    </rkm-modal>
</template>

<script>
// Mixins.
import {object, repository} from '@/mixins'

export default {
    computed: {
        validations() {
            return {
                ciap: {required: !this.model.cid},
                cid: {required: !this.model.ciap},
                situacao: {required: true},
                observacao: {max: 500},
            }
        },
    },
    created() {
        this.repositories = {
            ciap: this.getConectaSusRepository('geral').ciap,
            cid: this.getConectaSusRepository('sigtap.cid'),
        }
    },
    data: () => ({
        fields: {
            ciap: [
                {key: 'codigo', searchable: true},
                {key: 'descricao', searchable: true},
            ],
            cid: [
                {key: 'codigo', searchable: true},
                {key: 'nome', searchable: true},
            ],
        },
        item: null,
        model: {
            ciap: null,
            cid: null,
            situacaoId: null,
            observacao: null,
        },
    }),
    methods: {
        open(item = null) {
            this.item = item

            if (this.item) {
                this.edit()
            } else {
                this.create()
            }

            this.$refs.RkmModal.show()
        },
        create() {
            this.resetForm()
        },
        edit() {
            this.model = this.clone({
                ciap: this.item.ciap,
                cid: this.item.cid,
                situacaoId: this.item.situacaoId,
                observacao: this.item.observacao,
            })
        },
        store() {
            this.data.model.problemasCondicoesOutros.push(this.prepareData())
        },
        update() {
            Object.assign(this.item, this.prepareData())
        },
        prepareData() {
            return {
                ciap: this.model.ciap ? {
                    id: this.model.ciap.id,
                    codigo: this.model.ciap.codigo,
                    descricao: this.model.ciap.descricao,
                } : null,
                cid: this.model.cid ? {
                    id: this.model.cid.id,
                    codigo: this.model.cid.codigo,
                    nome: this.model.cid.nome,
                } : null,
                situacaoId: this.model.situacaoId,
                situacaoNome: this.data.form.situacoes.find(situacao => situacao.id === this.model.situacaoId)?.nome ?? null,
                observacao: this.model.observacao,
            }
        },
        save() {
            this.$refs.RkmForm.validate()
                .then(valid => {
                    if (valid === false) return

                    if (this.item) {
                        this.update()
                    } else {
                        this.store()
                    }

                    this.$refs.RkmModal.hide()
                })
        },
        resetForm() {
            this.item = null
            this.model.ciap = null
            this.model.cid = null
            this.model.situacaoId = null
            this.model.observacao = null
        },
    },
    mixins: [object, repository],
    props: {
        data: {required: true, type: Object},
    },
}
</script>
